import createSyntax from './create.js';
import lexerConfig from './config/lexer.js';
import parserConfig from './config/parser.js';
import walkerConfig from './config/walker.js';

export default createSyntax({
    ...lexerConfig,
    ...parserConfig,
    ...walkerConfig
});
